import Link from 'next/link'
import {useRouter} from 'next/router'
import {MouseEvent} from 'react'

import {IconArrowRightExtraBold} from '@defign/asset'
import {BiImage, isCard} from '@financial/common-bi'
import {Action, sendAULog} from '@financial/common-logs'
import {ConnectType, getConnectPagePath} from '@mydata/utils/connect'
import classNames from 'classnames/bind'

import {QRType} from '$constants/insurance/qrBridgeTitle'
import {INTERNAL_ROUTES} from '$constants/internal-routes'
import {useContentsBanner} from '$hooks/insurance/contents/useContentsBanner'
import useInsuranceMyAssetQuery from '$hooks/insurance/useInsuranceMyAssetQuery'
import {useValidApp} from '$hooks/useValidApp'
import {BASE_PATH} from '$share/config'
import baseOrigin from '$utils/baseOrigin'
import buildUrl from '$utils/buildUrl'
import {sendClickNlog} from '$utils/nlog'

import Styles from './InsuranceTipContent.module.scss'

const cx = classNames.bind(Styles)

export default function InsuranceBanner() {
    const router = useRouter()
    const {isValidApp} = useValidApp()

    const banner = useContentsBanner()

    const {data: myDataRegistrationData} = useInsuranceMyAssetQuery()

    function handleInsuranceClick(e: MouseEvent<HTMLAnchorElement>) {
        if (!isValidApp) {
            e.preventDefault()

            const landingUrl =
                myDataRegistrationData?.isMydataInsuranceConnected && banner?.endUrl
                    ? buildUrl({
                          pathname: banner?.endUrl.pathname || '',
                          ...(banner?.endUrl.query &&
                              typeof banner?.endUrl.query === 'object' && {query: banner?.endUrl.query}),
                      })
                    : getConnectPagePath({
                          type: ConnectType.NewConnection,
                          curl: window.location.href,
                          rurl: `${baseOrigin}${BASE_PATH}${INTERNAL_ROUTES.INSURANCE_MY_HOME}`,
                      })
            router.replace(
                {
                    pathname: router.pathname,
                    query: {...router.query, showAppDownloadQR: true, appBridgeUrl: landingUrl, qrType: QRType.INSU},
                },
                undefined,
                {shallow: true},
            )
            return
        }

        sendClickNlog('insutipdetail.product')
        sendAULog({page: 'insu', area: 'D', service: 'md', code: 'insu_tip_detail_restered_my'}, Action.Click)
    }

    if (!banner) {
        return null
    }

    return (
        <Link href={banner?.endUrl} className={cx('link')} onClick={handleInsuranceClick}>
            <div className={cx('bi-box')}>
                <span className={cx('bi')}>
                    <BiImage
                        biId={{
                            mydataOrgCode: banner.org?.orgCode,
                        }}
                        type={
                            isCard({
                                mydataOrgCode: banner.org?.orgCode,
                            })
                                ? 'Plate'
                                : 'Profile'
                        }
                    />
                </span>
            </div>
            <div className={cx('corp-box')}>
                <span className={cx('corp')}>
                    {banner.org?.displayName2 || banner.org.displayName}
                    <span className={cx('my')}>내 보험</span>
                </span>
                <strong className={cx('name')}>{banner.name}</strong>
                <span className={cx('icon-arrow')}>
                    <IconArrowRightExtraBold width={9} height={12} fill="#1e1e23" />
                </span>
            </div>
        </Link>
    )
}
